// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { uniq as _uniq, assign as _assign, mapValues } from 'lodash';
import trim from 'app/shared/helpers/trim';

import { useUpdatePipelineVariable } from '@ion/api';
import {
  MrH,
  MrText,
  MrLink,
  MrModal,
  MrForm,
  MrInputText,
  MrButton,
  MrButtonList,
  useForm,
  generateId,
  formValidators,
} from '@ion/components';

import styles from './index.module.scss';

export default function PipelineVarsModal({ pipeline, setPipelineVariablesModalOpen }) {
  const stagedRevisions = pipeline.pipelineIntegrations.map(pipelineIntegration => pipelineIntegration.stagedRevision);
  const stagedRevision = stagedRevisions.find(p => p.readyForDeploy === false);

  const formId = generateId();
  const [updatePipelineVariable, { isAllowed: updatePipelinePermission }] = useUpdatePipelineVariable();

  const { formState, resetError, submitForm, setField } = useForm(formId);
  const { validateRequired } = formValidators;

  const onVariablesFormSubmit = () => {
    const { data: pipelineVars, isValid } = submitForm();

    // if submitted user data is valid, update pipeline var with data and mark as populated
    // TODO (EunHye 2024.02.01.) we upsert stagedRevision.pipelineVars
    // Until we refactor the data model, it updates values by merging
    if (pipelineVars && isValid) {
      updatePipelineVariable({
        id: stagedRevision.id,
        pipelineVars: _assign({}, stagedRevision.pipelineVars, mapValues(pipelineVars, trim)),
        readyForDeploy: true,
      });

      setPipelineVariablesModalOpen(false);
    }
  };

  if (!stagedRevision) {
    return null;
  }

  const uniquePipelineVariableNames = _uniq(stagedRevision.playbook.pipeline_variables.map(({ name }) => name));

  return (
    <MrModal
      closeModal={() => {
        setPipelineVariablesModalOpen(false);
      }}
      styleNames="allowOverflow"
    >
      <div className={styles.header}>
        <MrH h="h3" sans styleNames="noMargin">
          Editing Pipeline Variables
        </MrH>
      </div>
      <div className={styles.content}>
        <MrForm onSubmit={onVariablesFormSubmit} id={formId}>
          <>
            <MrText styleNames="marginBottom">
              Set <b>Pipeline Variables</b> for{' '}
              <b>Revision {stagedRevision.revision || stagedRevision?.playbook?.revision}</b> of your{' '}
              <b>{stagedRevision.displayName || stagedRevision?.playbook?.integration?.name}</b> integration. Until you
              provide values for this pipeline, you will not be able to deploy this Revision.
            </MrText>

            {uniquePipelineVariableNames.map(name => {
              const value = stagedRevision.pipelineVars[name];

              return (
                <MrInputText
                  onInput={resetError}
                  validators={[validateRequired()]}
                  label={name}
                  name={name}
                  value={formState[name]?.value ?? value ?? ''}
                  errorMsg={formState[name]?.errorMsg}
                  key={name}
                  onChange={setField}
                  fullWidth
                />
              );
            })}
            <MrButtonList
              styleNames="marginTop"
              buttons={[
                <MrButton text="Save" key="save" disabled={!updatePipelinePermission} />,
                <MrLink
                  onClick={() => {
                    setPipelineVariablesModalOpen(false);
                  }}
                  styleNames="gray"
                  key="cancel"
                >
                  Cancel
                </MrLink>,
              ]}
            />
          </>
        </MrForm>
      </div>
    </MrModal>
  );
}

PipelineVarsModal.propTypes = {
  pipeline: PropTypes.object,
  setPipelineVariablesModalOpen: PropTypes.func.isRequired,
};
